import React from 'react';
import ReactToolTip from 'react-tooltip';
import {STYLE_RECORDING_INFO_ITEM} from "../Recording";

const TOOLTIP_SPEED_ID = 'speedTip';

/**
 * A component that displays speed
 * information on the recording form
 */
const Speed = ({speed}) => (
    <div style={STYLE_RECORDING_INFO_ITEM}>
        <div data-tip data-for={TOOLTIP_SPEED_ID}>
            <i className="fas fa-angle-double-right"/> {speed + "MPH"}
        </div>
        <ReactToolTip id={TOOLTIP_SPEED_ID}>
            <span>The average speed throughout the duration of the recording.</span>
        </ReactToolTip>
    </div>
);


export default Speed;



// WEBPACK FOOTER //
// ./src/components/recording/information/Speed.jsx